var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let apiLoadedCallbacks = [];
let apiLoaded = false;

window.onYouTubeIframeAPIReady = () => {
  apiLoadedCallbacks.forEach(apiLoadedCallback => apiLoadedCallback());
  apiLoadedCallbacks = [];
  apiLoaded = true;
};

class Youtube {
  constructor(_ref) {
    let {
      el,
      videoUrl,
      loop
    } = _ref;
    const regex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/ ]{11})/i; // eslint-disable-line no-useless-escape

    this.el = el;
    this.id = videoUrl.match(regex)[1] || null;
    this.onApiLoaded = this._onApiLoaded.bind(this);
    this.isReady = false;
    this.onReady = this._onReady.bind(this);
    this.onReadyCallback = null;
    this.loop = loop ? 1 : 0;
    this.onStateChange = this._onStateChange.bind(this);
    this.onPlayCallback = null;

    if (apiLoaded) {
      this._onApiLoaded();
    } else {
      apiLoadedCallbacks.push(this.onApiLoaded);
    }
  }

  play() {
    return new Promise(resolve => {
      this.onPlayCallback = resolve;

      if (this.isReady) {
        this.player.playVideo();
      } else {
        this.onReadyCallback = () => {
          this.player.playVideo();
        };
      }
    });
  }

  pause() {
    return new Promise(resolve => {
      this.onPlayCallback = resolve;

      if (this.isReady) {
        this.player.pauseVideo();
      } else {
        this.onReadyCallback = () => {
          this.player.pauseVideo();
        };
      }
    });
  }

  autoplay() {
    return new Promise(resolve => {
      this.onPlayCallback = resolve;

      if (this.isReady) {
        this.player.playVideo();
        this.player.mute();
      } else {
        this.onReadyCallback = () => {
          this.player.playVideo();
          this.player.mute();
        };
      }
    });
  }

  unload() {
    this.player.destroy();
  }

  _onApiLoaded() {
    const playerVars = {
      modestbranding: true,
      showinfo: false,
      controls: false,
      loop: this.loop,
      rel: 0
    };

    if (this.loop) {
      // This is required to allow 'loop' to work based on the YouTube api
      playerVars.playlist = this.id;
    }

    this.player = new YT.Player(this.el, {
      videoId: this.id,
      playerVars,
      events: {
        onReady: this.onReady,
        onStateChange: this.onStateChange
      }
    });
  }

  _onReady() {
    this.isReady = true;

    if (this.onReadyCallback) {
      this.onReadyCallback();
    }
  }

  _onStateChange(event) {
    const state = event.data;

    if (this.onPlayCallback && state === YT.PlayerState.BUFFERING) {
      this.onPlayCallback();
      this.onPlayCallback = null;
    }
  }
}

class Video {
  constructor(el, options) {
    this.el = el;
    this.options = options;
    this.platform = el.getAttribute('data-video').trim();
    this.playButton = el.querySelector('[data-video-play-button]');
    this.videoEl = el.querySelector('[data-video-element]');
    this.onPlayClick = this._onPlayClick.bind(this);
    this.onPauseClick = this._onPauseClick.bind(this);
    this.autoplay = this._autoplay.bind(this);
    this.video = null;
    this.videoData = {
      el: this.videoEl.childNodes[0],
      videoUrl: this.videoEl.getAttribute('data-video-url'),
      loop: this.options && this.options.loop
    };

    switch (this.platform) {
      case 'youtube':
        this.video = new Youtube(this.videoData);
        break;

      case 'vimeo':
        this.video = new VimeoPlayer(this.videoData);
        break;

      default:
        this.video = null;
        break;
    }

    this.el.addEventListener('click', this.onPlayClick);

    if (this.playButton) {
      if (this.options && this.options.autoplay) {
        this.autoplay();
      }

      this.playButton.addEventListener('click', this.onPlayClick);
    }
  }

  _onPlayClick() {
    this.el.classList.add('video-loading');
    this.video.play().then(() => {
      this.el.classList.add('video-transitioning');
      setTimeout(() => {
        this.el.classList.remove('video-loading');
        this.el.classList.remove('video-transitioning');
        this.el.classList.add('video-playing');
      }, 200);
    });
  }

  _onPauseClick() {
    this.video.pause();
  }

  _autoplay() {
    this.el.classList.add('video-loading');
    this.video.autoplay().then(() => {
      this.el.classList.add('video-transitioning');
      setTimeout(() => {
        this.el.classList.remove('video-loading');
        this.el.classList.remove('video-transitioning');
        this.el.classList.add('video-playing');
      }, 200);
    });
  }

  play() {
    this._onPlayClick();
  }

  pause() {
    this._onPauseClick();
  }

  unload() {
    this.el.removeEventListener('click', this.onPlayClick);

    if (this.playButton) {
      this.playButton.removeEventListener('click', this.onPlayClick);
    }

    if (this.video) {
      this.video.unload();
    }
  }

  destroy() {
    this.unload();
  }
}

class DynamicFaqItem {
  constructor(component) {
    this.refs =  {
      toggle: '.js-faq-toggle',
      video: '.js-faq-video'
    };

    this.dom = {
      $component: component,
      $toggles: component.querySelectorAll(this.refs.toggle),
      $videos: component.querySelectorAll(this.refs.video)
    };

    this.state = {
      closedClass: 'is-closed',
      openClass: 'is-open'
    };

    this.init();
  }

  init() {
    const { dom } = this;

    this.initToggles();
    
    if (dom.$videos.length > 0) {
      this.initVideos();
    }
  }

  initToggles() {
    const { dom } = this;
    dom.$toggles.forEach($toggle => {
      $toggle.addEventListener('click', this.toggleFaq.bind(this))
    })
  }

  toggleFaq(e) {
    const { dom, state } = this;
    const $btn = e.currentTarget
    const $content = $btn.nextElementSibling
    const $wrapper = $btn.parentNode
    const expanded = $btn.getAttribute("aria-expanded") === "true" || false;
    $btn.setAttribute("aria-expanded", !expanded);

    if (expanded) {
      var currentHeight = $content.offsetHeight;
      var targetHeight = 0;
      var time = 0;
      var step = currentHeight / time;
      var interval = setInterval(() => {
          currentHeight -= step;
          if (currentHeight <= targetHeight) {
              clearInterval(interval);
              currentHeight = targetHeight;
          }
          $content.style.height = currentHeight + 'px';
      }, 1);
      $wrapper.classList.add(state.closedClass);
      $wrapper.classList.remove(state.openClass);
    } else {
      var targetHeight = $content.scrollHeight;
      var currentHeight = 0;
      var time = 0;
      var step = targetHeight / time;
      var interval = setInterval(() => {
          currentHeight += step;
          if (currentHeight >= targetHeight) {
              clearInterval(interval);
              currentHeight = targetHeight;
          }
          $content.style.height = currentHeight + 'px';
      }, 1);
      $wrapper.classList.add(state.openClass);
      $wrapper.classList.remove(state.closedClass);
    }
  }

  initVideos() {
    const { dom } = this;
    dom.$videos.forEach($video => {
      new Video($video)
    }) 
  }
}

class TemplatePage {
  constructor(component) {
    this.refs = {
      dynamicFaqItem: '.js-dynamic-faq-item'
    };

    this.dom = {
      $component: component,
      $dynamicFaqItems: component.querySelectorAll(this.refs.dynamicFaqItem)
    };

    this.state = {};

    this.init();
  };

  init() {
    this.initDynamicFaqItems()
  }

  initDynamicFaqItems() {
    const { dom } = this;
    dom.$dynamicFaqItems.forEach($faqItem => {
      new DynamicFaqItem($faqItem)
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const $page = document.querySelector(".js-page")
  new TemplatePage($page)
})